import React from "react"
import placeholder from "../../assets/img/company-logo-placeholder.png";
import "./UserAvatar.css"
import { connect } from "react-redux"

function CollegeLogo(props) {
  return (
    <div
      className="college-logo"
    >
      <img
        src={props.logo || placeholder}
        // className="user-avatar-img"
        alt="company logo"
      />
      {props.children}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    logo: state.college.institution.logo,
  }
}

export default connect(mapStateToProps)(CollegeLogo);
